export default {
  circleProgress: [
    { content: 'React.js', percentage: '60' },
    { content: 'Database (SQL)', percentage: '55' }
  ],
  straightProgress: [
    {
      content: 'HTML5 and CSS3',
      percentage: '65'
    },
    { content: 'Frontend framework (Bootstrap, Bulma)', percentage: '60' },
    { content: 'Javascript', percentage: '50' },
    { content: 'Node.js', percentage: '35' }
  ]
}
